import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useMount } from 'ahooks';

export default function useActiveId(props: {
  defaultActiveId: string;
  activeIds: string[];
}): [string, React.Dispatch<React.SetStateAction<string>>] {
  const { defaultActiveId, activeIds } = props;

  const location = useLocation();

  const [activeId, setActiveId] = useState(defaultActiveId);

  useMount(() => {
    const pathParts = location.pathname.split('/').filter(Boolean);
    const lastPath = pathParts[pathParts.length - 1];

    if (activeIds?.includes(lastPath)) {
      setActiveId(lastPath);
    } else {
      setActiveId(defaultActiveId);

      const newPathParts = [...pathParts];
      newPathParts[newPathParts.length - 1] = defaultActiveId;
      const newPathname = `/${newPathParts.join('/')}`;

      history.replaceState(null, '', newPathname);
    }
  });

  return [activeId, setActiveId];
}
